export const SET_USERS_DETAILS = 'SET_USERS_DETAILS';
export const REMOVE_USERS_DETAILS = 'REMOVE_USERS_DETAILS';
